import React from 'react';
import { Link } from 'react-router-dom';
import { ExclamationTriangleIcon } from '@heroicons/react/24/outline';

const NotFoundPage = () => {
  return (
    <div className="flex flex-col items-center justify-center min-h-[calc(100vh-12rem)] text-center px-4 py-12 bg-figma-dark-bg-primary">
      <ExclamationTriangleIcon className="h-20 w-20 text-figma-dark-primary mb-6 animate-fade-in-up" />
      <h1 className="text-5xl md:text-6xl font-bold text-figma-dark-text-primary mb-4 animate-fade-in-up" style={{animationDelay: '0.1s'}}>404</h1>
      <h2 className="text-2xl md:text-3xl font-semibold text-figma-dark-text-primary mb-6 animate-fade-in-up" style={{animationDelay: '0.2s'}}>Page Not Found</h2>
      <p className="text-lg text-figma-dark-text-secondary mb-8 max-w-md animate-fade-in-up" style={{animationDelay: '0.3s'}}>
        Oops! The page you're looking for doesn't seem to exist. It might have been moved, deleted, or you mistyped the URL.
      </p>
      <Link 
        to="/"
        className="bg-figma-dark-primary hover:bg-figma-dark-primary-hover text-white font-semibold px-8 py-3.5 rounded-lg text-base transition-all duration-300 shadow-lg hover:shadow-xl transform hover:scale-105 animate-fade-in-up" style={{animationDelay: '0.4s'}}
      >
        Go Back to Homepage
      </Link>
    </div>
  );
};

export default NotFoundPage; 